export default __webpack_public_path__ + "static/Leaf10-9b051be3795054b0f6c81d1fa0af7784.png";